export * from "\/tmp\/autoscript\/tapir_dmon_83c4afc6132a92e675dd6e0f7a670136\/build\/index.barrel.js";